import React, { useState, useRef, useEffect } from "react";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function SearchBar() {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (!search.trim()) return;
    navigate(`/busca?q=${encodeURIComponent(search.trim())}`);
  };

  return (
    <div className="relative w-full max-w-md md:flex-1">
      <form onSubmit={handleSearch} className="relative">
        <input
          type="text"
          placeholder="Pesquise seu produto"
          className="w-full py-2 px-4 pr-6 rounded-md bg-gray-800 text-white placeholder-gray-400 focus:border-transparent focus:ring-1 focus:ring-green-500  mmb:text-[13px] smb:text-sm xl:text-base"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button
          type="submit"
          className="absolute right-0 top-0 h-full mmb:px-2 smb:px-3 text-gray-400 hover:text-white transition-colors">
          <Search className="mmb:w-4 mmb:h-4 smb:w-5 smb:h-5 flex" />
        </button>
      </form>
    </div>
  );
}
